<template>
  <div>
    <page-title title="Add New Station" />
    <station-fields :item="item" v-on:submit="onSubmit" v-on:cancel="onCancel" :is-editable="isEditable">
      <template v-slot:save>Add</template>
    </station-fields>
  </div>
</template>

<script>
import CrudOperationsMixin from '../Common/CrudOperationsMixin.js'
     
export default {
  name: "StationAdd",
  mixins: [CrudOperationsMixin],
  props: {},
  data() {
    return {
      item: {
        address1: '',
        address2: '',
        city: '',
        country: 'US',
        displayCity: 'New Station',
        displayType: 'ALL',
        faxNumber: '',
        headEmail: '',
        headName: '',
        isActive: true,
        isOnMap: true,
        name: 'New Station',
        name2: '',
        notes: '',
        phoneNumber: '',
        postalCode: '',
        startYear: null,
        state: '',
        website: ''
      }
    };
  },
  computed: {
    isEditable: function () {
      return this.$root.$data.authenticatedUser.roles.some(x => x == "SiteAdmin");
    },
  },
  methods: {
    onCancel(evt) {
      this.$router.push('/station');
    },
    onSubmit(evt) {
      this.createQuery('/graphql/management', {
        query: `
          mutation ($station: StationCreateInputOGT!) {
            createStation(station: $station) {
              id,
              name
            }
          }`,
        variables: {
          'station': this.item
        }}, () => {
          this.$router.push('/station');
        }, null, 'Station', this.item.name);
    }   
  },
  mounted () {
  }
};
</script>